module.exports = __webpack_public_path__ + "img/25-ranger.54b0f2b7.png";